/**
 * Video view component.
 * @module components/theme/View/VideoVIew
 */

import React from 'react';

/**
 * File view component class.
 * @function VideoView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */

const VideoView = ({ content }) => {
  return (
    <>
      {/*eslint-disable-next-line jsx-a11y/media-has-caption*/}
      <video src={content.file.download} controls type="video/mp4" />
    </>
  );
};
export default VideoView;
